import { DataEntry } from '../../../lib/types';
import { enrollStudentInCourse } from '../../../modules/course/api';
import { Roster } from '../../../modules/course/types';

export const enrollStudentUseCase = (
  courseId: number, courseFreeLinkToken?: string, spotAvailableToken?: string,
): Promise<DataEntry<Roster>> => {
  return enrollStudentInCourse(courseId, courseFreeLinkToken, undefined, spotAvailableToken);
};
